import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function pageItems(current, totalPages) {
    if (totalPages <= 7)
        return Array.from({ length: totalPages }, (_, i) => i);
    const pages = [0];
    const start = Math.max(1, current - 1);
    const end = Math.min(totalPages - 2, current + 1);
    if (start > 1)
        pages.push(null);
    for (let i = start; i <= end; i += 1)
        pages.push(i);
    if (end < totalPages - 2)
        pages.push(null);
    pages.push(totalPages - 1);
    return pages;
}
export function AdminPagination({ page, totalPages, onPageChange }) {
    if (totalPages <= 1)
        return null;
    const items = pageItems(page, totalPages);
    return (_jsxs("nav", { className: "admin-pagination", "aria-label": "\u041D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u044F \u043F\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C", children: [_jsx("button", { type: "button", disabled: page <= 0, onClick: () => onPageChange(page - 1), children: "\u00AB" }), items.map((item, index) => item == null ? (_jsx("span", { className: "admin-pagination-ellipsis", children: "\u2026" }, `e-${index}`)) : (_jsx("button", { type: "button", className: item === page ? 'is-active' : undefined, onClick: () => onPageChange(item), children: item + 1 }, item))), _jsx("button", { type: "button", disabled: page >= totalPages - 1, onClick: () => onPageChange(page + 1), children: "\u00BB" })] }));
}
